import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerContainer = styled.div`
  display: inline-block;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border: ${(props) => props.borderWidth || Math.max(2, props.size * 0.15)}px solid;
  border-color: ${(props) => props.color || '#000000'};
  border-right-color: transparent;
  border-radius: 50%;
  animation: ${spin} ${(props) => props.animationDuration || '0.75s'} linear infinite;
`;

/**
 * Custom ClipLoader - Drop-in replacement for react-spinners ClipLoader
 *
 * @param {number} size - Size in pixels (default: 20)
 * @param {boolean} loading - Show/hide spinner (default: true)
 * @param {string} color - Spinner color (default: '#000000')
 * @param {number} speedMultiplier - Animation speed multiplier (default: 1)
 * @param {object} cssOverride - Additional CSS styles (borderWidth, margin, etc.)
 */
export const ClipLoader = ({
  size = 20,
  loading = true,
  color = '#000000',
  speedMultiplier = 1,
  cssOverride = {},
  ...props
}) => {
  if (!loading) return null;

  // Extract borderWidth from cssOverride if provided
  const { borderWidth, ...otherStyles } = cssOverride;

  // Filter out non-standard props that might cause warnings
  // (width, className, style are fine - they're standard HTML attributes)
  const { width, ...restProps } = props;

  return (
    <SpinnerContainer
      size={size}
      color={color}
      borderWidth={borderWidth}
      animationDuration={`${0.75 / speedMultiplier}s`}
      style={otherStyles}
      {...restProps}
    />
  );
};
